module.exports = __webpack_public_path__ + "assets/images/pages/eu-funds/FEDER-IG190-Re-acciona.png?623c903f";